<ng-content *ngIf="activated; else deactivated"></ng-content>
<ng-template #deactivated>
  <ng-content select=".icon"></ng-content><span fxFlex="100%"  fxLayoutAlign="start center">{{value}}</span>
</ng-template>
